// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__2plzt","active":"Pagination_active__1R0gI"};